import { googleAdapter } from "../adapters/googleAdapter";
import AdsCreateTemplate from "../common/AdsCreateTemplateView";

export default function CreateGoogleTemplateView({ template }: { template?: any }) {
  return <AdsCreateTemplate adapter={googleAdapter} template={template} />;
}
